export default __webpack_public_path__ + "static/media/btn-view-all-course.0119ceb4.svg";